export default {"src":"/_next/static/media/1.06e9ab60.svg","height":105,"width":98,"blurWidth":0,"blurHeight":0};